import { CustomerAddress, MeteringPointAddress, InputAddress, BasicDataAddress } from '../types/address';

export const generateAddress = (
  addressSource: MeteringPointAddress | CustomerAddress | InputAddress | BasicDataAddress | undefined,
  onlyAddress: boolean,
  invoiceComment?: string,
): string => {
  if (!addressSource) {
    return '';
  } else {
    let addressDetails = [
      addressSource.careOf,
      addressSource.streetName,
      addressSource.houseNumber,
      addressSource.houseLetter,
      addressSource.residence,
      addressSource.zipCode,
      addressSource.cityName,
    ];

    if (onlyAddress) {
      addressDetails = addressDetails.splice(0, 5);
    }

    let address = '';

    if (addressSource.careOf) {
      address = 'c/o ';
    }

    for (const component of addressDetails) {
      if (component) {
        address += component + ' ';
      }
    }

    if (invoiceComment) {
      address += '(' + invoiceComment + ')';
    }

    return address;
  }
};
